import React from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { UserQuestion } from '../../__generated__/graphql';

interface QuizProgressBarProps {
  userQuestions: UserQuestion[];
  currentIndex: number;
  onQuestionClick: (index: number) => void;
}

const QuizProgressBar: React.FC<QuizProgressBarProps> = ({
  userQuestions,
  currentIndex,
  onQuestionClick,
}) => {
  const getQuestionIcon = (userQuestion: UserQuestion) => {
    if (
      userQuestion.selectedOption.desc &&
      userQuestion.selectedOption.isAnswer !== null
    ) {
      return userQuestion.selectedOption.isAnswer ? (
        <CheckCircleIcon sx={{ color: 'green', fontSize: 22 }} />
      ) : (
        <CancelIcon sx={{ color: 'red', fontSize: 22 }} />
      );
    } else {
      return <RadioButtonUncheckedIcon sx={{ color: 'gray', fontSize: 22 }} />;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '600px',
          mb: 3,
          mt: 2,
        }}
      >
        {userQuestions.map((userQuestion, index) => {
          const isClickable =
            index === 0 || !!userQuestions[index - 1]?.selectedOption.desc;

          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: isClickable ? 'pointer' : 'auto',
                opacity: isClickable ? 1 : 0.5,
              }}
              onClick={() => isClickable && onQuestionClick(index)}
            >
              <Box>{getQuestionIcon(userQuestion)}</Box>
              {index < userQuestions.length - 1 && (
                <Box
                  sx={{
                    flexGrow: 1,
                    height: '2px',
                    backgroundColor: 'gray',
                    width: '10px',
                    mx: 1,
                  }}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default QuizProgressBar;
